"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const react_1 = __importDefault(require("react"));
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const SaveToDraftModal = (props) => {
    const { sidebarIsOpen, setSidebarIsOpen, saveDraftsFromPopup } = props;
    return (react_1.default.createElement(ModalPortal_1.default, { isOpen: sidebarIsOpen, onClose: () => setSidebarIsOpen(false) },
        react_1.default.createElement(Popup_1.default, { onClose: () => setSidebarIsOpen(false) },
            react_1.default.createElement(ConfirmationPopup_1.default, { onConfirm: () => saveDraftsFromPopup(true), confirmButtonText: 'Save to drafts', cancelButtonText: 'Discard', onCancel: () => saveDraftsFromPopup(false), title: 'Would you like to save the incomplete works to drafts?' },
                react_1.default.createElement("p", null, "This will save any incomplete works (works with error) to your drafts.")))));
};
exports.default = SaveToDraftModal;
